import { render, staticRenderFns } from "./FormItemSpecificManage.vue?vue&type=template&id=6a7ab99c"
import script from "./FormItemSpecificManage.vue?vue&type=script&lang=js"
export * from "./FormItemSpecificManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports